export const merryCardMenuViews = [
  "store",
  "chat-history",
  "notifications",
  "account",
  "currency",
  "support",
  "language",
  "widget",
] as const;

export type MerryCardMenuView = (typeof merryCardMenuViews)[number];

export const merrySystemMenuSubmenuViews = [
  "currency",
  "language",
  "support",
] as const;

export type MerrySystemMenuSubmenuView =
  (typeof merrySystemMenuSubmenuViews)[number];

export interface MerryCardMenuSize {
  height: 156 | 240 | 362 | 576 | 646 | 656 | 1032;
  width: 240 | 320;
}

const viewConfig = {
  store: { figmaNodeId: "300:35696", height: 1032, width: 320 },
  "chat-history": {
    figmaNodeId: "326:40877",
    height: 656,
    width: 320,
  },
  notifications: {
    figmaNodeId: "327:29623",
    height: 646,
    width: 320,
  },
  account: { figmaNodeId: "311:5848", height: 576, width: 320 },
  currency: { figmaNodeId: "327:30009", height: 156, width: 240 },
  support: { figmaNodeId: "361:70098", height: 362, width: 240 },
  language: { figmaNodeId: "327:30223", height: 156, width: 240 },
  widget: { figmaNodeId: "316:80526", height: 240, width: 240 },
} as const satisfies Record<
  MerryCardMenuView,
  MerryCardMenuSize & { figmaNodeId: string }
>;

const systemMenuPageConfig = {
  account: { figmaNodeId: "556:99434", flyoutTop: null },
  currency: { figmaNodeId: "556:100577", flyoutTop: 390 },
  language: { figmaNodeId: "556:101646", flyoutTop: 438 },
  support: { figmaNodeId: "556:103916", flyoutTop: 282 },
  store: { figmaNodeId: "556:105154", flyoutTop: null },
} as const;

export type MerrySystemMenuPage = keyof typeof systemMenuPageConfig;

export function getMerryCardMenuFigmaNodeId(view: MerryCardMenuView) {
  return viewConfig[view].figmaNodeId;
}

export function getMerryCardMenuSize(
  view: MerryCardMenuView,
): MerryCardMenuSize {
  const config = viewConfig[view];

  return { height: config.height, width: config.width };
}

export function isMerryCardMenuView(
  value: string,
): value is MerryCardMenuView {
  return merryCardMenuViews.some((view) => view === value);
}

export function isMerrySystemMenuSubmenuView(
  value: MerryCardMenuView,
): value is MerrySystemMenuSubmenuView {
  return merrySystemMenuSubmenuViews.some((view) => view === value);
}

export function getMerrySystemMenuPageFigmaNodeId(
  page: MerrySystemMenuPage,
) {
  return systemMenuPageConfig[page].figmaNodeId;
}

export function getMerrySystemMenuFlyoutTop(
  view: MerrySystemMenuSubmenuView,
) {
  return systemMenuPageConfig[view].flyoutTop;
}
